import { Types } from "../actions/MaintenanceTypeActions.js";

const initialState = {
    Loading: false,
    isTaskUpdated: false,
    plants: {},
    maintenanceTypes: {},
    mailGroup: {},
    mailGroupPeriod: {},
};

export const MaintenanceTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_MAINTENANCE_TYPE:
            return {
                ...state,
                maintenanceTypes: action.payload ?? state.maintenanceTypes,
            };
        case Types.SET_MAIL_GROUP:
            return {
                ...state,
                mailGroup: action.payload ?? state.mailGroup,
            };
        case Types.SET_MAIL_GROUP_PERIOD:
            return {
                ...state,
                mailGroupPeriod: action.payload ?? state.mailGroupPeriod,
            };
        case Types.SET_PLANTS:
            return {
                ...state,
                plants: action.payload ?? state.plants,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
